<div class="two-factor-container d-flex flex-column justify-content-center align-items-center p-2">
    <div class="d-flex align-items-center mb-4 pb-1">
        <span class="message mb-4 pb-1"> پیام متنی حاوی کد ۶رقمی به شماره موبایل <span dir="ltr">{{phoneNumber}}</span> ارسال شد.</span>
    </div>
    <span class="title mb-1">کد ارسال‌شده را وارد کنید.</span>
    <section class="d-flex justify-content-between align-items-center px-3" [ngClass]="{'error-code': !_confirmationOTP}" dir="ltr"
             #element>
        <span>T-</span>
        <input #firstInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="firstNumber"
               (input)="checkInput($event, 'secondInput')">
        <input #secondInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="secondNumber"
               (input)="checkInput($event, 'thirdInput')">
        <input #thirdInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="thirdNumber"
               (input)="checkInput($event, 'forthInput')">
        <input #forthInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="forthNumber"
               (input)="checkInput($event, 'fifthInput')">
        <input #fifthInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="fifthNumber"
               (input)="checkInput($event, 'sixthInput')">
        <input #sixthInput maxlength="1" class="input-number" type="tel" pattern="\d*" [(ngModel)]="sixthNumber"
               (input)="checkInput($event, 'firstInput')">
    </section>
    <section class="d-flex justify-content-center align-items-end">
        <morva-linear-notifiction *ngIf="!_confirmationOTP" class="ms-1" message="کد واردشده اشتباه است."
                                  messageType="error"></morva-linear-notifiction>
        <div class="countDown-timer" *ngIf="!resend && (time$ | async) > -1">{{showTime}} مانده تا ارسال مجدد</div>
        <div class="resend-code" *ngIf="resend" (click)="resendOTP()">ارسال مجدد</div>
    </section>
</div>
